import React from 'react';
import { PromotionsCard } from './PromotionsCard';

export const PromotionsPage = () => {
  return (
    <>
      <PromotionsCard />
    </>
  );
};